var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.7502C12.4454 23.4763 10.4032 23.9168 8.16666 23.9168C6.92309 23.9168 5.73963 23.7807 4.66666 23.5349C2.82132 23.1122 2.33333 22.0264 2.33333 20.2838V7.71646C2.33333 6.56749 3.5467 5.77835 4.66666 6.03486C5.73963 6.28062 6.92309 6.41683 8.16666 6.41683C10.4032 6.41683 12.4454 5.97625 14 5.25016C15.5546 4.52408 17.5967 4.0835 19.8333 4.0835C21.0769 4.0835 22.2603 4.2197 23.3333 4.46546C25.1786 4.88812 25.6667 5.97392 25.6667 7.71646V20.2838C25.6667 21.4329 24.4533 22.222 23.3333 21.9655C22.2603 21.7196 21.0769 21.5835 19.8333 21.5835C17.5967 21.5835 15.5546 22.024 14 22.7502Z",
    stroke: "#8F9DAC",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 14.0002C16.9167 15.611 15.6108 16.9168 14 16.9168C12.3892 16.9168 11.0833 15.611 11.0833 14.0002C11.0833 12.3893 12.3892 11.0835 14 11.0835C15.6108 11.0835 16.9167 12.3893 16.9167 14.0002Z",
    stroke: "#8F9DAC",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 15.1665V15.177",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5833 12.8242V12.8347",
    stroke: "#8F9DAC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayments);
export default __webpack_public_path__ + "static/media/Payments.4d234c243847e97bd1221636b8867b4a.svg";
export { ForwardRef as ReactComponent };